import { UnitedStatesOperationTaxes } from '../operation-taxes'

export const IllinoisOperationTaxes = {
  ...UnitedStatesOperationTaxes,
} as const
